<template>
  <div class="flex flex-col gap-100">
    <LcCard
      v-for="{ headline, text, value, name } in cards"
      :key="name"
      body-class="p-100"
      class="bg-secondary-secondary-bold"
      shadow="none"
    >
      <section class="modal-hint-body items-center gap-200">
        <div>
          <h2 class="paragraph-bold">{{ headline }}</h2>

          <p class="text-secondary-secondary">{{ text }}</p>
        </div>

        <LcSwitch
          v-bind="{ name, value }"
          :aria-label-text="$t('highfrequencygame.addontoggle.default.switch')"
          :data-click-name="`${name.toLowerCase()}_prize_modal_switch`"
          @update:value="(value) => setAddOn(name, value!)"
        />
      </section>
    </LcCard>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()
const { addOns, disabledAddOns, prizeTier, selectedAddOns, setAddOn } = useHighFrequencyGame()

const cards = computed(() => {
  if (!prizeTier.value) return []

  return addOns.value
    .filter((addOnName) => !disabledAddOns.value.includes(addOnName))
    .map((addOnName) => ({
      headline: t(`highfrequencygame.addon.${addOnName}`),
      name: addOnName,
      text: t(`highfrequencygame.addontoggle.${addOnName}.text`),
      value: selectedAddOns.value.includes(addOnName),
    }))
})
</script>

<style lang="scss" scoped>
.modal-hint-body {
  display: grid;
  grid-template-columns: 1fr auto;
}
</style>
